import { Component } from 'react';
import { inject, observer } from 'mobx-react';

class GoogleTagManagerAction extends Component {

	constructor(props) {
		super(props);
		if (typeof window.dataLayer === 'object') { 
			if (props.action === 'purchase-success') {	
				const payload = this.generatePurchaseSuccessPayload();														
				window.dataLayer.push(
					payload
				)
			}
		}	
	}

	generatePurchaseSuccessPayload() {
		const cashsale = this.props.shopStore.cashsale.get();
		let coupon = '';
		let couponPromotions = cashsale.promotions.filter(promo => 
			promo.applicabilitymode === 'MANUALLY' && promo.applicabilitystatus === 'APPLIED'
		);
		if (couponPromotions.length > 0) {
			coupon = couponPromotions[0].couponcode_display;
		}		
		let products = [];
		cashsale.lineitems.map(lineItem =>
			products.push({
				name: lineItem.description,
				id: lineItem.itemname,
				price: lineItem.amount,
				quantity: lineItem.quantity,				
			})
		);
		let payload = {
			event: 'purchase-success',
			ecommerce: {
				purchase: {
					actionField: {
						id: cashsale.ordernumber,
						revenue: cashsale.total,
						coupon: coupon,
					},
					products: products,
				}
			}
		}	
		return payload;
	}

	render() {
		return null;
	}

}

export default inject('shopStore')(observer(GoogleTagManagerAction));



// WEBPACK FOOTER //
// ./src/components/GoogleTagManagerAction.js